import { Instant } from "@js-joda/core";
import { useState, useEffect, useCallback } from "react";

function useTimerThreshold(thresholdInSeconds = 0, initialStartTime = Instant.now().toEpochMilli()) {
  const [startTime, setStartTime] = useState(initialStartTime);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (thresholdInSeconds === 0) {
      setIsExpired(false);
      return () => {};
    }

    const interval = setInterval(() => {
      const elapsedSeconds = (Instant.now().toEpochMilli() - startTime) / 1000;
      setIsExpired(elapsedSeconds > thresholdInSeconds);
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime, thresholdInSeconds]);

  const resetTimer = useCallback((newStartTime = Instant.now().toEpochMilli()) => {
    setStartTime(newStartTime);
    setIsExpired(false);
  }, []);

  return { isExpired, resetTimer };
}

export default useTimerThreshold;
